import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-polygons-animation',
    imports: [],
    templateUrl: './polygons-animation.html',
    styleUrl: './polygons-animation.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PolygonsAnimation {}
